const parseFilterDataMapping = {
    created_on: ['created_on:gte', 'created_on:lte'],
    date: ['date:gte', 'date:lte'],
    latest_exported_on: 'latest_exported_on:is'
}
  
export default parseFilterDataMapping
  